module.exports = __webpack_public_path__ + "static/media/videoIcon.b91e5695.jpg";